export default function AssessmentDocumentDirective() {
  return {
    template: require('./assessment-document.html'),
    scope: {
      assessmentId: '=',
      assessment: '=',
      canEdit: '=',
      canDelete: '=',
      assessmentDocument: '=',
    },
    controller: 'AssessmentDocumentController',
    controllerAs: 'assessmentDocumentVM',
    bindToController: true,
    replace: true
  };
}
